import {
  Box,
  Button,
  Flex,
  Stack,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Image,
  Skeleton,
  Avatar,
} from "@chakra-ui/core";
import React from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router";
import { Link } from "react-router-dom";
import { getUserProfile } from "../../../api/user.service";
import useAuth from "../../../context/AuthContext";
import { formatDate } from "../../../lib/utils/utils";

const ProfileDetailPage = () => {
  const initialProfile = {
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    gender: "",
    mentor: {},
  };

  const [profile, setUserProfile] = React.useState(initialProfile);
  const [isFetchLoading, setIsFetchLoading] = React.useState(false);

  const history = useHistory();
  const { pathname } = useLocation();
  const match = useRouteMatch();

  const {
    state: { user },
  } = useAuth();

  React.useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        setIsFetchLoading(true);
        const { data } = await getUserProfile();

        setUserProfile(data);
        console.log(data);
        setIsFetchLoading(false);
      } catch (error) {
        console.log("err", error);
      }
    };

    fetchUserProfile();
  }, []);

  const onClickHandler = () => {
    history.push(`/dashboard/create-profile?prevLocation=${pathname}`);
  };

  const expertise =
    profile.mentor.expertise && JSON.parse(profile.mentor.expertise);
  return (
    <Box bg='white' w='100%' px={["2", "10"]} pb='40' pt='10'>
      <Flex align='center' direction={["column", "row"]}>
        <Skeleton isLoaded={!isFetchLoading} rounded='full'>
          <Box>
            {user.gender === null ? (
              <Avatar
                src='https://bit.ly/broken-link'
                bg='green.400'
                size='sm'
              />
            ) : user.gender === "male" ? (
              <Avatar
                size='xl'
                src={
                  profile?.photo_url
                    ? profile?.photo_url
                    : "https://img.icons8.com/color/92/000000/user-male-circle--v1.png"
                }
                alt='User Avatar'
                rounded='full'
              />
            ) : (
              <Avatar
                size='xl'
                src={
                  profile?.photo_url
                    ? profile?.photo_url
                    : "https://img.icons8.com/color/92/000000/circled-user-female-skin-type-6--v1.png"
                }
                alt='User Avatar'
                rounded='full'
              />
            )}
          </Box>
        </Skeleton>

        <Stack ml='4' mr='auto'>
          <Skeleton isLoaded={!isFetchLoading}>
            <Text
              fontSize='xl'
              fontWeight='800'
              textAlign={["center", "start"]}
              mb={["4", "0"]}
            >
              {profile.first_name} {profile.last_name}
            </Text>
          </Skeleton>
          {/* <Skeleton isLoaded={!isFetchLoading}>
            <Text fontSize='16px' fontWeight='500'>
              <strong>Date of Birth: </strong>
              {profile.profile.date_of_birth
                ? profile.profile.date_of_birth
                : "N/A"}
            </Text>
          </Skeleton> */}

          <Skeleton isLoaded={!isFetchLoading}>
            <Text fontSize='16px' fontWeight='500'>
              <strong>Registered Email: </strong> {profile.email}
            </Text>
          </Skeleton>
          <Skeleton isLoaded={!isFetchLoading}>
            <Text fontSize='16px' fontWeight='500'>
              <strong>Date Added: </strong>

              {formatDate(profile.created_at)}
            </Text>
          </Skeleton>
        </Stack>
        <Box
          alignSelf={["start", "end"]}
          flex='1'
          ml={["4", "auto"]}
          mt={["2", "0"]}
          justifySelf={["start", "flex-end"]}
          d='flex'
          justifyContent={["start", "flex-end"]}
          alignItems={["flex-start", "flex-end"]}
        >
          <Menu>
            <MenuButton as={Button} rightIcon='settings'>
              Settings
            </MenuButton>
            <MenuList>
              <Link
                to={{ pathname: `${match.url}/edit-profile`, state: profile }}
              >
                <MenuItem>Edit Profile</MenuItem>
              </Link>
              <Link
                to={{
                  pathname: `${match.url}/change-password`,
                  state: { profile, user },
                }}
              >
                <MenuItem>Change Password</MenuItem>
              </Link>
              <Link
                to={{
                  pathname: `${match.url}/upload-picture`,
                  state: { profile, user },
                }}
              >
                <MenuItem>Set Profile Picture</MenuItem>
              </Link>
            </MenuList>
          </Menu>
        </Box>
      </Flex>
      <Stack my='8' spacing={["4", "8"]}>
        <Flex justify='space-between'>
          <Box bg='white' py='4' px='6' shadow='sm' flexBasis={["100%", "50%"]}>
            <Text fontSize='18px' fontWeight='800'>
              Nationality
            </Text>
            <Skeleton isLoaded={!isFetchLoading}>
              <Text fontSize='16px' fontWeight='500'>
                {profile.mentor.nationality
                  ? profile.mentor.nationality
                  : "N/A"}
              </Text>
            </Skeleton>
          </Box>
          <Box bg='white' py='4' px='6' shadow='sm' flexBasis={["100%", "50%"]}>
            <Text fontSize='18px' fontWeight='800'>
              Sex
            </Text>
            <Skeleton isLoaded={!isFetchLoading}>
              <Text fontSize='16px' fontWeight='500'>
                {profile.gender ? profile.gender : "N/A"}
              </Text>
            </Skeleton>
          </Box>
        </Flex>
        <Flex justify='space-between' wrap={["wrap", "nowrap"]}>
          <Box bg='white' py='4' px='6' shadow='sm' flex='1'>
            <Text fontSize='18px' fontWeight='800'>
              Contact
            </Text>
            <Skeleton isLoaded={!isFetchLoading}>
              <Text fontSize='16px' fontWeight='500'>
                {profile.phone_number ? profile.phone_number : "N/A"}
              </Text>
            </Skeleton>
          </Box>

          <Box bg='white' py='4' px='6' shadow='sm' flex='1'>
            <Text fontSize='18px' fontWeight='800'>
              Residential Address
            </Text>
            <Skeleton isLoaded={!isFetchLoading}>
              <Text fontSize='16px' fontWeight='500'>
                {profile.mentor.residential_address
                  ? profile.mentor.residential_address
                  : "N/A"}
              </Text>
            </Skeleton>
          </Box>
        </Flex>
        <Flex justify='space-between'>
          <Box bg='white' py='4' px='6' shadow='sm' flexBasis='50%'>
            <Text fontSize='18px' fontWeight='800'>
              SKills
            </Text>
            <Skeleton isLoaded={!isFetchLoading}>
              <Text fontSize='16px' fontWeight='500'>
                {profile.mentor?.skills ? profile.mentor?.skills : "N/A"}
              </Text>
            </Skeleton>
          </Box>

          <Box bg='white' py='4' px='6' shadow='sm' flex='1'>
            <Text fontSize='18px' fontWeight='800'>
              Expertise
            </Text>
            <Stack spacing='1'>
              {expertise && expertise.length > 0 ? (
                expertise.map((expertise, i) => (
                  <Skeleton isLoaded={!isFetchLoading} key={i}>
                    <Text fontSize='16px' fontWeight='500'>
                      {expertise}
                    </Text>
                  </Skeleton>
                ))
              ) : (
                <Skeleton isLoaded={!isFetchLoading}>
                  <Text fontSize='16px' fontWeight='500'>
                    N/A
                  </Text>
                </Skeleton>
              )}
            </Stack>
          </Box>
        </Flex>
        <Box bg='white' py='4' px='6' shadow='sm' flex='1'>
          <Text fontSize='18px' fontWeight='800'>
            Research Interests
          </Text>
          <Skeleton isLoaded={!isFetchLoading}>
            <Text fontSize='16px' fontWeight='500'>
              {profile.mentor.research_interests
                ? profile.mentor.research_interests
                : "N/A"}
            </Text>
          </Skeleton>
        </Box>
        <Box bg='white' py='4' px='6' shadow='sm' flex='1'>
          <Text fontSize='18px' fontWeight='800'>
            Biography
          </Text>
          <Skeleton isLoaded={!isFetchLoading}>
            <Text fontSize='16px' fontWeight='500'>
              {profile.mentor.biography ? profile.mentor.biography : "N/A"}
            </Text>
          </Skeleton>
        </Box>
        <Box bg='white' py='4' px='6' shadow='sm' flex='1'>
          <Text fontSize='18px' fontWeight='800'>
            Experience
          </Text>
          <Skeleton isLoaded={!isFetchLoading}>
            <Text fontSize='16px' fontWeight='500'>
              {profile.mentor.experience ? profile.mentor.experience : "N/A"}
            </Text>
          </Skeleton>
        </Box>
        <Box bg='white' py='4' px='6' shadow='sm' flex='1'>
          <Text fontSize='18px' fontWeight='800'>
            Motivation
          </Text>
          <Skeleton isLoaded={!isFetchLoading}>
            <Text fontSize='16px' fontWeight='500'>
              {profile.mentor.motivation ? profile.mentor.motivation : "N/A"}
            </Text>
          </Skeleton>
        </Box>
        <Box bg='white' py='4' px='6' shadow='sm' flexBasis='50%'>
          <Text fontSize='18px' fontWeight='800'>
            Benefit
          </Text>
          <Skeleton isLoaded={!isFetchLoading}>
            <Text fontSize='16px' fontWeight='500'>
              {profile.mentor.benefit ? profile.mentor.benefit : "N/A"}
            </Text>
          </Skeleton>
        </Box>

        {user.hasProfile ? (
          ""
        ) : (
          <Stack isInline alignSelf={["start", "flex-end"]} align='center'>
            <Text fontSize='14px' fontWeight='700'>
              NB: Your profile is not complete
            </Text>
            <Button onClick={onClickHandler}>Set Up profile</Button>
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default ProfileDetailPage;
